<template>
    <v-layout row>
        <v-flex xs7 class="pr-3">
            <v-select autocomplete :disabled="disabled" :placeholder="$t('label.approverType')" v-bind:items="types" v-model="type" :rules="rules.type" :no-data-text="$t('message.warning.noData')"></v-select>
        </v-flex>
        <v-flex xs4>
            <!-- <app-money v-model="costThreshold" prefix="R$"></app-money> -->
            <v-text-field prefix="R$" v-model="costThreshold" :rules="validation.numeric" :maxlength="constants.LENGTH_UNIT_COST"></v-text-field>
            <!-- <v-text-field prefix="R$" v-model="form.unitCost" :rules="validation.requiredBiggerThanZero" :maxlength="constants.LENGTH_UNIT_COST" ></v-text-field> -->
        </v-flex>
        <v-flex xs1 class="pa-2" v-if="!disabled">
            <v-icon @click="remove" style="cursor:pointer">delete</v-icon>
        </v-flex>
    </v-layout>
</template>

<script>
import constants from '@/helpers/constants';
import utilities from '@/helpers/utilities';
import validation from '@/helpers/validation';

// import Money from '@/components/shared/Money';

export default {
    props: {
        model: {
            type: Object,
            required: true,
            default: () => { },
        },
        list: {
            type: Array,
            required: false,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data() {
        return {
            constants,
            validation,

            costThreshold: this.model.costThreshold.toString().replace('.', ','),
            type: (this.model.approverType).id,

            rules: {
                type: [
                    ...validation.required,
                    () => this.list.filter(item =>
                        item.uuid !== this.model.uuid && item.approverType.id === this.type,
                    ).length === 0 || this.$t('message.validation.unique'),
                ],
            },
        };
    },

    computed: {
        types() {
            return utilities.combobox(
                this.$store.getters.approverTypesValueText,
                this.type,
            );
        },
    },

    components: {
        // appMoney: Money,
    },
    watch: {
        type: 'update',
        costThreshold: 'update',
    },

    methods: {
        update() {
            this.$emit('change', {
                costThreshold: utilities.toFixedFloat(this.costThreshold),
                status: this.model.status,
                approverType: { id: this.type },
                uuid: this.model.uuid,
            });
            this.costThreshold = this.costThreshold.toString().replace('.', ',');
        },
        remove() {
            this.$emit('remove', this.model.uuid);
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/types/demand/Step.vue